export const CANTON_NAMES = {
  AG: "Aargau", AI: "Appenzell Rhodes-Intérieures", AR: "Appenzell Rhodes-Extérieures", BE: "Berne",
  BL: "Bâle-Campagne", BS: "Bâle-Ville", FR: "Fribourg", GE: "Genève", GL: "Glaris", GR: "Grisons",
  JU: "Jura", LU: "Lucerne", NE: "Neuchâtel", NW: "Nidwald", OW: "Obwald", SG: "Saint-Gall",
  SH: "Schaffhouse", SO: "Soleure", SZ: "Schwytz", TG: "Thurgovie", TI: "Tessin", UR: "Uri",
  VD: "Vaud", VS: "Valais", ZG: "Zoug", ZH: "Zurich",
};
